import { render } from "./edit_fzr.vue?vue&type=template&id=568cf280&scoped=true"
import script from "./edit_fzr.vue?vue&type=script&lang=js"
export * from "./edit_fzr.vue?vue&type=script&lang=js"

import "./edit_fzr.vue?vue&type=style&index=0&id=568cf280&scoped=true&lang=css"

import exportComponent from "E:\\devops.aliyun\\deyi\\baobei_web2\\web2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-568cf280"]])

export default __exports__